import {Injectable, OnInit} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {throwError as observableThrowError} from 'rxjs/internal/observable/throwError';
import {Headers, Http, RequestOptions} from '@angular/http';

@Injectable()
export class WalletDetailService extends BaseService implements OnInit {


    constructor(public http: HttpClient,
                public httpP: Http) {
        super('wallet-detail', http);
    }

    ngOnInit(): void {
    }


    addAdjust(data: any, signature: string) {
        const header: Headers = new Headers();

        header.append('Signature', signature);
        const options = new RequestOptions({headers: header});
        return this.httpP.post(`https://api-admin-v2.latipay.net/apm/manual/regulation`, data , options).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

}
